"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const user = (sdk) => {
    const { sdkConfig: { url }, defaultVersion, } = sdk;
    const httpClient = sdk.httpClient;
    return {
        getUser: async (userId) => {
            const endpoint = `${url}/${defaultVersion}/admin/users/${userId}`;
            const result = await httpClient.get(endpoint);
            return result.data;
        },
        getUserByQuery: async (query) => {
            const endpoint = `${url}/${defaultVersion}/admin/users`;
            const result = await httpClient.get(endpoint, { query });
            return result.data;
        },
        updateUser: async (userId, payload) => {
            const endpoint = `${url}/${defaultVersion}/admin/users/${userId}`;
            const result = await httpClient.put(endpoint, { payload });
            return result.data;
        },
    };
};
exports.default = user;
